import { InjectionToken } from '@angular/core';
import { LoyaltyProgramRepository } from 'src/app/core/repositories/loyalty-program.repository';

export const LoyaltyProgramRepositoryToken: InjectionToken<LoyaltyProgramRepository> =
  new InjectionToken<LoyaltyProgramRepository>('Loyalty Program Injection Token');
